import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineRotate360Icon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 6C6.3 6 2 8.15 2 11c0 2.45 3.19 4.38 7.71 4.88l-.42.41a1.001 1.001 0 0 0-.2958.71 1.0003 1.0003 0 0 0 .2958.71 1.001 1.001 0 0 0 .71.2958.9997.9997 0 0 0 .71-.2958l2-2a1.0002 1.0002 0 0 0 .21-.33c.1-.2435.1-.5165 0-.76a1.0002 1.0002 0 0 0-.21-.33l-2-2a1.0041 1.0041 0 1 0-1.42 1.42l.12.11C6 13.34 4 12 4 11c0-1.22 3.12-3 8-3s8 1.78 8 3c0 .83-1.45 2-4.21 2.6a1.0006 1.0006 0 0 0-.645.4291 1.001 1.001 0 0 0 .29 1.3931.9985.9985 0 0 0 .3638.1442.9984.9984 0 0 0 .3912-.0064c3.65-.8 5.81-2.5 5.81-4.56 0-2.85-4.3-5-10-5Z"/>
  </SvgIcon>
}

export default LineRotate360Icon
